import { Component, Input } from '@angular/core';
import { TabNavigationService } from '../../../form-application/mortgage-application/services/tab-navigation.service';
import { ReferenceDataLabels } from '../../../lib/constants/reference-data-labels';
import { MortgageApplicationNavigationEvents } from '../../constants/mortgage-application-navigation-events';

@Component({
  selector: 'boi-progress-stepper-item',
  templateUrl: './progress-stepper-item.component.html',
  styleUrls: ['./progress-stepper-item.component.scss']
})
export class ProgressStepperItemComponent {
  @Input() stepTitle: string;
  @Input() status: any;
  @Input() hasSubmitValidationError?: boolean;
  @Input() IsPending?: boolean;

  public referenceDataLabels = ReferenceDataLabels;

  constructor(public tabNavigationService: TabNavigationService) {}

  public scrollToSection(sectionTitleCode: string): void {
    this.tabNavigationService.emitEvent({
      type: MortgageApplicationNavigationEvents.GoToSection,
      data: { sectionTitleCode }
    });
  }
}
